const SELECTORS = {
    container: '.ranch-type-filter',
    item: '.ranch-type-filter__item',
};

const CLASSES = {
    expanded: 'is-expanded',
};

export class RanchTypeFilterHover {
    constructor(block) {
        this.block = block;
        this.currentExpanded = null;
        this.hoverTimeout = null;

        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);

        this.init();
    }

    init() {
        this.cacheDOM();
        if (!this.container) return;

        this.bindEvents();
    }

    cacheDOM() {
        this.container = this.block.querySelector(SELECTORS.container);
        this.items = this.container?.querySelectorAll(SELECTORS.item);
    }

    bindEvents() {
        this.items?.forEach((item) => {
            item.addEventListener('mouseenter', this.handleMouseEnter);
            item.addEventListener('mouseleave', this.handleMouseLeave);
        });
    }

    handleMouseEnter(e) {
        const item = e.currentTarget;

        // Clear any pending timeout
        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
            this.hoverTimeout = null;
        }

        // Close previous item immediately
        if (this.currentExpanded && this.currentExpanded !== item) {
            this.currentExpanded.classList.remove(CLASSES.expanded);
        }

        // Open new item
        item.classList.add(CLASSES.expanded);
        this.currentExpanded = item;
    }

    handleMouseLeave(e) {
        const item = e.currentTarget;

        // Delay closing to prevent flicker when moving between items
        this.hoverTimeout = setTimeout(() => {
            item.classList.remove(CLASSES.expanded);
            if (this.currentExpanded === item) {
                this.currentExpanded = null;
            }
        }, 50);
    }

    destroy() {
        this.items?.forEach((item) => {
            item.removeEventListener('mouseenter', this.handleMouseEnter);
            item.removeEventListener('mouseleave', this.handleMouseLeave);
        });

        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
        }
    }
}
